import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cloneDeep } from 'lodash';
import DOMPurify from 'dompurify';
import {
  getDealerFlow,
  getDisabledOnlineSteps,
} from '@upstart/harmony/lib/flow-utils';
import { CLIENT_TYPE, OnlineStep } from '@upstart/harmony/lib/constants';
import { Tabs, Tab } from 'react-bootstrap/lib';
import dealersActions from '../../redux/dealers/actions';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import { FlowList, AvailableList } from '../../components/FlowList';
import ErrorMessage from '../../components/ErrorMessage';

class DealerFlow extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { dealerId } = this.props.match.params;
    this.props.actions.resetDealer();
    this.props.actions.dealerRequest({ dealerId });
  }

  componentDidUpdate() {
    if (!this.state.flow && this.props.dealer.id) {
      this.setState({ flow: getDealerFlow(this.props.dealer) });
    }
  }

  onFlowChange = (flowListType, flow) => {
    // Get the key to determine which flow we should update
    const newFlow = cloneDeep(this.state.flow);
    newFlow[flowListType] = cloneDeep(flow);
    this.setState({ flow: newFlow });
  };

  // eslint-disable-next-line consistent-return
  onSave = async () => {
    const stepFlowConfig = this.state.flow;
    const paymentsIndex = stepFlowConfig[CLIENT_TYPE.ONLINE].findIndex(
      (s) => s.id === OnlineStep.paymentBuilder,
    );
    const protectionPlansIndex = stepFlowConfig[CLIENT_TYPE.ONLINE].findIndex(
      (s) => s.id === OnlineStep.upgradePackages,
    );
    if (this.validateOnlineFlow(paymentsIndex, protectionPlansIndex)) {
      return false;
    }

    this.setState({ error: false });

    const dealerToUpdate = {
      id: this.props.dealer.id,
      stepFlowConfig: cloneDeep(stepFlowConfig),
    };

    this.props.actions.updateDealerRequest({
      dealer: dealerToUpdate,
      isDiffObject: true,
    });
  };

  validateOnlineFlow = (paymentsIndex, protectionPlansIndex) => {
    let invalid = false;
    if (paymentsIndex === -1 && protectionPlansIndex > -1) {
      invalid = true;
      this.setState({
        error: {
          message: `<h4>Online Error</h4>
          <strong>Protection Plans</strong> step requires <strong>Customize Payments</strong> step`,
        },
      });
    }
    return invalid;
  };

  render() {
    const { dealer, error } = this.props;
    const disabledInstoreSteps = [];
    const disabledOnlineSteps = getDisabledOnlineSteps(dealer);
    if (!dealer?.wizard?.testDrive?.enabled)
      disabledOnlineSteps.push(OnlineStep.testDrive);
    if (!dealer?.wizard?.delivery?.enabled && !dealer?.wizard?.pickup?.enabled)
      disabledOnlineSteps.push(OnlineStep.schedulePickup);

    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="dealers-table">
          <DealerNav />
          {error && <ErrorMessage error={error} />}
          <div className="dealer-editor-container">
            {this.state.error && (
              <div
                className="error-container"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(this.state.error.message),
                }}
              />
            )}
            {dealer && this.state.flow && (
              <div className="table-responsive">
                <div className="dealer-flow-container">
                  <Tabs id="widget-config-tabs" className="flow-page-container">
                    <Tab
                      key={CLIENT_TYPE.IN_STORE}
                      eventKey={CLIENT_TYPE.IN_STORE}
                      title="In Store"
                    >
                      <FlowList
                        flow={this.state.flow[CLIENT_TYPE.IN_STORE]}
                        flowListType={CLIENT_TYPE.IN_STORE}
                        dealer={this.props.dealer}
                        onChange={this.onFlowChange}
                      />
                      <AvailableList
                        flow={this.state.flow[CLIENT_TYPE.IN_STORE]}
                        flowListType={CLIENT_TYPE.IN_STORE}
                        onChange={this.onFlowChange}
                        disabledSteps={disabledInstoreSteps}
                      />
                    </Tab>
                  </Tabs>
                </div>
                <button className="btn btn-primary" onClick={this.onSave}>
                  Save
                </button>
              </div>
            )}
          </div>
        </div>
      </SidebarContainer>
    );
  }
}

DealerFlow.propTypes = {
  actions: PropTypes.object,
  dealer: PropTypes.object,
  match: PropTypes.object,
  params: PropTypes.object,
};

const mapStateToProps = ({ dealers }) => ({
  dealer: dealers.dealer,
  error: dealers.error,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...dealersActions }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(DealerFlow));
